var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('media-query-provider',{attrs:{"queries":{ mobile: '(max-width: 768px)' }}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }